import { defineStore } from 'pinia'
import router from '@/router'
import { store } from '@/store'
import { getUserInfo, getUserPermission, updateUserInfo, updatePassword } from '@/api/login'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      // userInfo: {
      //   id: 'user-001'
      // },
      userInfo: '',
      permissions: []
    }
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo;
    },
    getToken() {
      return localStorage.getItem('token');
    },
    getPermission(state) {
      return state.permissions
    }
  },
  actions: {
    setToken(info) {
      if (info) {
        localStorage.setItem('token', info)
      } else {
        localStorage.removeItem('token')
      }
    },
    setUserInfo(info) {
      this.userInfo = info
    },
    setPermission(info) {
      const { menu, auth } = info;
      (auth || []).forEach(v => {
        if (v.action) {
          this.permissions.push(v.action)
        }
      })
      menu.forEach(v => {
        this.permissions.push(v.name)
        if (v.name.includes('innopara') && v.children?.length > 0) {
          this.setPermission({ menu: v.children })
        }
      })
    },
    async getUserInfoAction() {
      if (!this.getToken) return null;

      const res = await getUserInfo();
      const data = { ...res.userInfo };
      this.setUserInfo({ ...data });
      const permission = await getUserPermission();
      this.setPermission(permission)
      return data;
    },
    async updateUserInfo(userInfo) {
      // TODO: 调用更新用户信息的API
      const res = await updateUserInfo(userInfo);
      if (res) {
        this.setUserInfo({ ...this.userInfo, ...userInfo });
      }
      return res;
    },
    async updatePassword(passwordInfo) {
      // TODO: 调用修改密码的API
      const res = await updatePassword(passwordInfo);
      return res;
    },
    async logout() {
      this.setToken(undefined);
      this.setUserInfo(null);
      localStorage.clear();
      // 回登陆页带上当前路由地址
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(router.currentRoute.value.fullPath),
        },
      });
    },
  },
  persist: true
})

export function useUserStoreWithOut() {
  return useUserStore(store);
}
